@if (formGenerator) {
  <form class="generator" [formGroup]="formGenerator?.form">
    @for (row of formGenerator?.fields; track $index) {
      <div class="row row--{{ row?.class }}">
        <!-- Heading -->
        @if (row.element === formFieldElement?.Heading) {
          <h2>{{ row.label | translate }}</h2>
        }
        <!-- Input -->
        @if (row.element === formFieldElement?.Input) {
          <mat-form-field
            class="form-field"
            hideRequiredMarker
            appearance="fill"
            subscriptSizing="dynamic">
            <mat-label>{{
              row.label | translate | requiredAsterisk: formGenerator?.form.controls[row.name]
            }}</mat-label>
            <input
              matInput
              [type]="row.type"
              [placeholder]="row.placeholder | translate"
              [formControlName]="row.name"
              [minlength]="row.minLength"
              [maxlength]="row.maxLength"
              [min]="row.min"
              [max]="row.max"
              class="{{ row.inputClass }}"/>
            @for (errorKey of getValidationErrorKeys(formGenerator?.form.controls[row.name]); track errorKey) {
              <mat-error>
                {{ 'validationErrors.' + errorKey | translate: { value: formGenerator?.form.controls[row.name].errors[errorKey] } }}
              </mat-error>
            }
          </mat-form-field>
        }
        <!-- Select / Multiselect -->
        @if (row.element === formFieldElement?.Select || row.element === formFieldElement?.SelectMultiple) {
          <mat-form-field
            class="form-field"
            hideRequiredMarker
            appearance="fill"
            subscriptSizing="dynamic">
            <mat-label>{{
              row.label | translate | requiredAsterisk: formGenerator?.form.controls[row.name]
            }}</mat-label>
            <mat-select
              matInput
              [formControlName]="row.name"
              [multiple]="row.element === formFieldElement?.SelectMultiple"
              [panelClass]="row.selectPanelClass">
              <!-- Add a default "None" to select unless multiselect -->
              @if (row.element !== formFieldElement?.SelectMultiple) {
                <mat-option>{{
                  'common.none' | translate
                }}</mat-option>
              }
              @for (option of row.options; track $index) {
                <mat-option [value]="option">
                  {{ row.displayFn ? (row.displayFn(option) | translate) : option }}
                </mat-option>
              }
            </mat-select>
            @if (formGenerator.form.controls[row.name].invalid) {
              <mat-error>
                {{ 'validationErrors.' + row.validationError | translate }}
              </mat-error>
            }
          </mat-form-field>
        }
        <!-- Checkbox -->
        @if (row.element === formFieldElement?.Checkbox) {
          <div class="mat-form-field form-field checkbox">
            <mat-checkbox [formControlName]="row.name">{{
              row.label | translate | requiredAsterisk: formGenerator?.form.controls[row.name]
            }}</mat-checkbox>
          </div>
        }
        <!-- Datepicker -->
        @if (row.element === formFieldElement?.Datepicker) {
          <mat-form-field
            class="form-field"
            hideRequiredMarker
            appearance="fill"
            subscriptSizing="dynamic">
            <mat-label>{{
              row.label | translate | requiredAsterisk: formGenerator?.form.controls[row.name]
            }}</mat-label>
            <input matInput [matDatepicker]="picker" [formControlName]="row.name" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (formGenerator.form.controls[row.name].invalid) {
              <mat-error>
                {{ 'validationErrors.' + row.validationError | translate }}
              </mat-error>
            }
          </mat-form-field>
        }
        <!-- Autocomplete -->
        @if (row.element === formFieldElement?.Autocomplete) {
          <payments-form-autocomplete
            [row]="row"
          ></payments-form-autocomplete>
        }
      </div>
    }
  </form>
}
